import { ColumnDef, SortState, Stage } from '@/components/operations/types';
import { COLUMNS as OPERATION_COLUMNS } from '@/components/operations/columns';
import { useOperationsData } from '@/components/operations/useOperationsData';
import { WORK_ORDER_COLUMNS } from '@/components/work-orders/columns';
import { useWorkOrdersData } from '@/components/work-orders/useWorkOrdersData';
import { SALES_ORDER_COLUMNS } from '@/components/sales-orders/columns';
import { useSalesOrdersData } from '@/components/sales-orders/useSalesOrdersData';

export type EntityKey = 'operations' | 'work-orders' | 'sales-orders';

export interface EntityConfig {
  key: EntityKey;
  label: string;
  pluralLabel: string;
  columns: ColumnDef<any>[];
  useData: () => any[];
  defaultSort?: SortState;
  titleColumnId?: string;
  stageAccessor?: (row: any) => Stage | undefined;
}

export const ENTITIES: Record<EntityKey, EntityConfig> = {
  operations: {
    key: 'operations',
    label: 'Operation',
    pluralLabel: 'operations',
    columns: OPERATION_COLUMNS,
    useData: useOperationsData,
    defaultSort: [{ columnId: 'date', direction: 'asc' }],
    titleColumnId: 'workOrderId',
    stageAccessor: (row) => row.stage as Stage,
  },
  'work-orders': {
    key: 'work-orders',
    label: 'Work Order',
    pluralLabel: 'work orders',
    columns: WORK_ORDER_COLUMNS,
    useData: useWorkOrdersData,
    defaultSort: [{ columnId: 'date', direction: 'asc' }],
    titleColumnId: 'workOrderId',
  },
  'sales-orders': {
    key: 'sales-orders',
    label: 'Sales Order',
    pluralLabel: 'sales orders',
    columns: SALES_ORDER_COLUMNS,
    useData: useSalesOrdersData,
    defaultSort: [{ columnId: 'date', direction: 'asc' }],
    titleColumnId: 'orderNumber',
  },
};

export const ENTITY_LIST: EntityConfig[] = [
  ENTITIES.operations,
  ENTITIES['work-orders'],
  ENTITIES['sales-orders'],
];
